module.exports = __webpack_public_path__ + "img/yidaiyilu@3x.7f012670.png";